import { Fonts } from "../../../const/font";
import { CustomFonts } from "../../../const/CustomFonts";
import WebFont from "webfontloader";
import { useEffect } from "react";
import { getFontWeights } from "../../UI/CommonComponents";

export default function FontImporter() {
    useEffect(() => {
        WebFont.load({
            google: {
                families: Fonts.filter((font: any) => font.linkHtml).map(
                    (font: any) => `${font.name}:${getFontWeights(font)}`
                )
            },
            custom: {
                families: CustomFonts.map((font) => font.name),
                urls: ["/fonts/custom-fonts.css"]
            },
            timeout: 2000 // Wait 2 seconds before starting to load fonts
        });
    }, []);

    return null;
}
